import { lessonRequestModalActionTypes } from './Constants';

const initialState = {
	open: false,
	booksForLessons: [],
	data: null,
	loading: true,
	loadingSlots: true,
	slots: [],
	lessonData: null,
};

export default function lessonRequestModalReducer(state = initialState, action) {
	const { type, payload } = action;
	const { data } = payload || {};

	switch (type) {
		case lessonRequestModalActionTypes.TOGGLE_LESSON_REQUEST_MODAL:
			return {
				...state,
				...data,
			};
		case lessonRequestModalActionTypes.GET_BOOKS_FOR_LESSONS:
		case lessonRequestModalActionTypes.ADD_LESSON_REQUEST:
		case lessonRequestModalActionTypes.GET_LESSON_BY_CHAPTER:
		case lessonRequestModalActionTypes.GET_SUBJECTS:
			return {
				...state,
				loading: true,
			};
		case lessonRequestModalActionTypes.GET_BOOKS_FOR_LESSONS_SUCCESS:
			return {
				...state,
				booksForLessons: data,
				loading: false,
			};
		case lessonRequestModalActionTypes.GET_BOOKS_FOR_LESSONS_ERROR:
		case lessonRequestModalActionTypes.ADD_LESSON_REQUEST_ERROR:
		case lessonRequestModalActionTypes.GET_LESSON_BY_CHAPTER_ERROR:
		case lessonRequestModalActionTypes.GET_SUBJECTS_ERROR:
			return {
				...state,
				loading: false,
			};
		case lessonRequestModalActionTypes.ADD_LESSON_REQUEST_SUCCESS:
			return {
				...state,
				...data,
				loading: false,
			};
		case lessonRequestModalActionTypes.GET_LESSON_BY_CHAPTER_SUCCESS:
			return {
				...state,
				lessonByChapter: data,
				loading: false,
			};
		case lessonRequestModalActionTypes.GET_SUBJECTS_SUCCESS:
			return {
				...state,
				subjects: data,
				loading: false,
			};
		case lessonRequestModalActionTypes.GET_AVAILABLE_SLOTS:
			return {
				...state,
				loadingSlots: true,
			};
		case lessonRequestModalActionTypes.GET_AVAILABLE_SLOTS_SUCCESS:
			return {
				...state,
				slots: data,
				loadingSlots: false,
			};
		case lessonRequestModalActionTypes.GET_AVAILABLE_SLOTS_ERROR:
			return {
				...state,
				loadingSlots: false,
			};
		case lessonRequestModalActionTypes.CLEAR_LESSON_REQUEST_MODAL_STATE:
			return initialState;
		default:
			return state;
	}
}
